import { ModalData, ValidationError } from '../models';
import { KeyValue } from '@angular/common';

export class ModalBase {
  message: string;
  title: string;
  translateParams: object;
  link: KeyValue<string, string>;

  constructor(data: string | { message: string, title: string } | ModalData) {
    this.setMessages(data);
  }

  protected setMessages(data: string | { message: string, title: string } | ModalData): void {
    if (data instanceof ModalData) {
      this.title = data.title;
      this.message = data.message;
      this.translateParams = data.translateParams;
      this.link = data.link;
    } else if (typeof data === 'string') {
      this.message = data;
    } else {
      this.message = data.message ? data.message : '';
      this.title = data.title ? data.title : '';
    }
  }
}
